const metaData = [
    { charset: "utf-8" },
    { name: "viewport", content: "width=device-width, initial-scale=1" },
    { name: "theme-color", content: "#00693E" },
    { name: "description", content: "Musa Institute for Academic and Skills Development offers comprehensive programs to enhance academic knowledge and skill sets for personal and professional growth." },
    { name: "keywords", content: "Musa Institute, Academic Development, Skills Development, Education, Professional Skills, Training, Courses" },
    { name: "author", content: "Muhammad Majid" },
    { name: "site_name", content: "Musa Institute for Academic and Skills Development" },
    { name: "application-name", content: "Musa Institute for Academic and Skills Development" }
  ];

  export default metaData;